"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = void 0;

var constants_1 = require("../lib/constants");

exports.initialState = {
  authenticationToken: null,
  authenticationStatus: constants_1.FETCH_STATUSES.INITIAL,
  loginUrl: null,
  isLoaded: false,
  hasError: false,
  error: null
};